// extracted by mini-css-extract-plugin
var _1 = "NA8gh";
export { _1 as "message" }
